import { TopToolbar } from 'react-admin';
import WithRole from 'src/components/common/WithRole';
import DownloadReportButton from './DownloadReportButton';
import { AdminGroup } from 'src/constants/roles';
import React from 'react';

interface ToolbarActionsProps {
    pageUrl: string;
    singleCenterId?: string | number;
}

export const ToolbarActions: React.FC<ToolbarActionsProps> = ({ pageUrl, singleCenterId }) => {
    return (
        <TopToolbar>
            <WithRole roles={AdminGroup}>
                <DownloadReportButton
                    pageUrl={pageUrl}
                    label="Завантажити звіт"
                    fallbackEducationCenterId={singleCenterId}
                />
            </WithRole>
        </TopToolbar>
    );
};
